import { IUser, eRole } from '@logicalcommander/types'

export interface ILoginRequest {
  companyId: string
  identity: string
  password: string
  language: string
  captchaToken?: string
}
export interface IAdminLoginResendMfaResponse {
  success: boolean
  mfaPendingToken: string
  expiresIn: number
}

export interface ILoginMfaVerifyRequest {
  mfaPendingToken: string
  code: string
}

export interface ITokenLoginResponseCommon {
  accepted: string[]
}

export enum EtypeTokenLoginResponse {
  LOGIN = 'LOGIN',
  MFA = 'MFA',
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
}
export interface IAdminLoginResendMfaRequest {
  mfaPendingToken: string
  language: string
}
export interface IPasswordExpiredResponseData {
  type: EtypeTokenLoginResponse.PASSWORD_EXPIRED
  requiresMfa: boolean
  mfaPendingTokenExpired: string
  daysSinceExpired: number
  passwordExpirationDays: number
  from?: string
}

export interface ILoginResponse {
  type: EtypeTokenLoginResponse.LOGIN
  companyToken: string
  token: string
  user: IUser
  common: ITokenLoginResponseCommon
}

export interface IMfaRequiredResponse {
  type: EtypeTokenLoginResponse.MFA
  requiresMfa: boolean
  mfaPendingToken: string
  expiresIn: number
}
export type IPasswordExpiredResponse = IPasswordExpiredResponseData | IMfaRequiredResponse

/** Response from setExpiredPassword: either full login or MFA required. */
export type ISetExpiredPasswordResponse = ILoginResponse | IMfaRequiredResponse

/** Token en Authorization header; newPassword en el body. */
export interface ISetExpiredPasswordRequest {
  mfaPendingToken: string
  newPassword: string
  mfaEnabled: boolean
  language: string
}

export type IAdminLoginResponse = ILoginResponse | IMfaRequiredResponse | IPasswordExpiredResponse

export interface IResetPasswordRequest {
  companyId: string
  identity: string
  language: string
  captchaToken: string
}

export interface ISetNewPasswordRequest {
  password: string
  token: string
}

export interface IVerifyEmailRequest {
  token: string
}

export interface IResendEmailVerificationRequest {
  identity: string
  language?: string
}

export enum EVerifyEmailStatus {
  VERIFIED = 'VERIFIED',
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
}

export interface IVerifyEmailResponse {
  status?: EVerifyEmailStatus | string
  response?: {
    status: EVerifyEmailStatus | string
  }
}

export interface IUpdateOwnPasswordResponse {
  statusCode: number
}

export interface IUpdateOwnPasswordRequest {
  oldPassword: string
  newPassword: string
}

export interface IUpdateOthersPasswordResponse {
  statusCode: number
}

export interface IUpdateOthersPasswordRequest {
  companyId: string
  identity: string
  newPassword: string
}

interface CustomRole {
  [key: string]: string
}
export type UserRole = eRole & CustomRole

export interface IActiveSession {
  jti: string
  /** Original sign-in (not updated on inactivity extend). */
  loginAt?: number
  issuedAt: number
  expiresAt: number
  ip?: string
  userAgent?: string
  sessionType?: 'normal' | 'remote_support'
  remoteSupport?: {
    requestedByIdentity: string
    requestedByName?: string
    operatorEmail: string
    connectedAt: number
  }
}

export type IRemoteSupportStatus = 'idle' | 'pending' | 'connected' | 'expired' | 'locked'

export interface IRemoteSupportRequestResponse {
  code: string
  expiresAt: number
  status: 'pending'
}

export interface IRemoteSupportStatusResponse {
  status: IRemoteSupportStatus
  code?: string
  expiresAt?: number
  operatorEmail?: string
  operatorName?: string
  connectedAt?: number
  requestedByIdentity?: string
}

export interface IExtendedSession {
  token: string
}
